module.exports = __webpack_public_path__ + "img/OutdatedTrendData.6356c7e5.png";